import {
    allFetch,
    ResultObj
} from "../Domain";

/**訂單配車查詢 (參數)
* @description 訂單配車查詢 (參數)
* @param allotment_time_start 配發日期起
* @param allotment_time_end 配發日期迄
*/
export interface OrderAllotmentLogSearchParams {
    allotment_time_start: string,
    allotment_time_end: string,
    page: number,
    num_per_page: number
}

/**@description 訂單配車查詢 (回傳) */
export interface OrderAllotmentLogSearchResItem {
    order: string;
    使用數: string;
    持有數: string;
    最大序號: string;
    最小序號: string;
    最近配發日: string;
    異常數: string;
    空白數: string;

}

/**@description 訂單配車查詢 */
export const OrderAllotmentLogSearch =
    async (obj: OrderAllotmentLogSearchParams = {
        allotment_time_start: '',
        allotment_time_end: '',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<OrderAllotmentLogSearchResItem[]>> => await allFetch('Order/OrderAllotmentLogSearch', obj);


/**批次新建空白訂單 (參數)
* @description 批次新建空白訂單 (參數)
* @param order_number_start 訂單編號起
* @param order_number_end 訂單編號迄
*/
export interface OrderCreateParams {
    order_number_start: string,
    order_number_end: string,
}

/**@description 批次新建空白訂單 */
export const OrderCreate =
    async (obj: OrderCreateParams = {
        order_number_start: '',
        order_number_end: '',
    }): Promise<ResultObj> => await allFetch('Order/OrderCreate', obj);



/**訂單保管查詢 (參數)
* @description 訂單保管查詢 (參數)
* @param allotment_time_start 配發日期起
* @param allotment_time_end 配發日期迄
* @param custody_unit_id 保管人(帳號編號)們
* @param custody_user_ids 保管單位(據點)流水號
* @param excel 是否匯出
*/
export interface OrderCustodySearchParams {
    allotment_time_start: string,
    allotment_time_end: string,
    custody_user_ids: string[],
    custody_unit_id: string,
    excel?: string,
}

/**@description 訂單保管查詢 (回傳) */
export interface OrderCustodySearchResItem {
    custody_user_id: string;
    order: string;
    user_cre_time: string;
    使用數: string;
    名稱: string;
    單位: string;
    持有數: string;
    最大序號: string;
    最小序號: string;
    最近配發日: string;
    異常數: string;
    空白數: string;
}

/**@description 訂單保管查詢 */
export const OrderCustodySearch =
    async (obj: OrderCustodySearchParams = {
        allotment_time_start: '',
        allotment_time_end: '',
        custody_user_ids: [],
        custody_unit_id: '',
    }): Promise<ResultObj<OrderCustodySearchResItem[]>> => await allFetch('Order/OrderCustodySearch', obj);

/**批次配發訂單(初次) (參數)
* @description 批次配發訂單(初次) (參數)
* @param order_number_start 訂單編號起
* @param order_number_end 訂單編號迄
* @param custody_unit_id 保管人(帳號編號)們
* @param custody_user_id 保管單位(據點)流水號
*/
export interface OrderAllotmentParams {
    order_number_start: string,
    order_number_end: string,
    custody_user_id: string,
    custody_unit_id: string,
}

/**@description 批次配發訂單(初次) */
export const OrderAllotment =
    async (obj: OrderAllotmentParams = {
        order_number_start: '',
        order_number_end: '',
        custody_user_id: '',
        custody_unit_id: '',
    }): Promise<ResultObj> => await allFetch('Order/OrderAllotment', obj);



/**批次配發訂單(非初次) (參數)
* @description 批次配發訂單(非初次) (參數)
* @param order_number_start 訂單編號起
* @param order_number_end 訂單編號迄
* @param custody_unit_id 保管人(帳號編號)們
* @param custody_user_id 保管單位(據點)流水號
*/
export interface OrderReAllotmentParams {
    order_number_start: string,
    order_number_end: string,
    custody_user_id: string,
    custody_unit_id: string,
}

/**@description 批次配發訂單(非初次) */
export const OrderReAllotment =
    async (obj: OrderReAllotmentParams = {
        order_number_start: '',
        order_number_end: '',
        custody_user_id: '',
        custody_unit_id: '',
    }): Promise<ResultObj> => await allFetch('Order/OrderReAllotment', obj);



/**訂單異常回報 (參數)
* @description 訂單異常回報(參數)
* @param OrderAbnormalReturn_objs 訂單異常回報obj
*/
export interface OrderAbnormalReturnParams {
    OrderAbnormalReturn_objs: OrderAbnormalReturn_obj[],
}

/**訂單異常回報obj
* @description 訂單異常回報obj
* @param order_id 訂單系統編號
* @param abnormal_return_status 異常回報狀態
* @param abnormal_return_note 異常回報備註
*/
export interface OrderAbnormalReturn_obj {
    order_id: string,
    abnormal_return_status: string,
    abnormal_return_note: string
}

/**@description 訂單異常回報 */
export const OrderAbnormalReturn =
    async (obj: OrderAbnormalReturnParams = {
        OrderAbnormalReturn_objs: [],
    }): Promise<ResultObj> => await allFetch('Order/OrderAbnormalReturn', obj);


/**訂單空白繳回 (參數)
* @description 訂單空白繳回 (參數)
* @param OrderAbnormalReturn_objs 訂單空白繳回obj
*/
export interface OrderBlankReturnParams {
    OrderBlankReturn_objs: OrderBlankReturn_obj[],
}

/**訂單空白繳回obj
* @description 訂單空白繳回obj
* @param order_id 訂單系統編號
* @param abnormal_return_note 異常回報備註
*/
export interface OrderBlankReturn_obj {
    order_id: string,
    abnormal_return_note: string
}

/**@description 訂單空白繳回 */
export const OrderBlankReturn =
    async (obj: OrderBlankReturnParams = {
        OrderBlankReturn_objs: [],
    }): Promise<ResultObj> => await allFetch('Order/OrderBlankReturn', obj);




/**訂單稽核 (參數)
* @description 訂單稽核 (參數)
* @param OrderAudit_objs 訂單稽核物件
*/
export interface OrderAuditParams {
    OrderAudit_objs: OrderAudit_obj[],
}

/**訂單稽核物件
* @description 訂單稽核物件
* @param order_id 訂單系統編號
* @param audit_status 稽核狀態
* @param audit_note 稽核備註
*/
export interface OrderAudit_obj {
    order_id: string,
    audit_status: string,
    audit_note: string
}

/**@description 訂單稽核 */
export const OrderAudit =
    async (obj: OrderAuditParams = {
        OrderAudit_objs: [],
    }): Promise<ResultObj> => await allFetch('Order/OrderAudit', obj);


/**訂單收回 (參數)
* @description 訂單收回 (參數)
* @param OrderTakeBack_objs 訂單收回物件
*/
export interface OrderTakeBackParams {
    OrderTakeBack_objs: OrderTakeBack_obj[],
}

/**訂單收回物件
* @description 訂單收回物件
* @param order_id 訂單系統編號
* @param audit_note 稽核備註
*/
export interface OrderTakeBack_obj {
    order_id: string,
    audit_note: string
}

/**@description 訂單收回 */
export const OrderTakeBack =
    async (obj: OrderTakeBackParams = {
        OrderTakeBack_objs: [],
    }): Promise<ResultObj> => await allFetch('Order/OrderTakeBack', obj);



// -------------------------------------------

/**訂單列表(自己的) (參數)
 *  @description 訂單列表(自己的) (參數)
 *  @param order_number_start 訂單編號起
 *  @param order_number_end 訂單編號迄
 *  @param allotment_time_start 領取日期起
 *  @param allotment_time_end 領取日期迄
 *  @param first_submit_time_start 申請日期起
 *  @param first_submit_time_end 申請日期迄
 *  @param order_id 訂單系統編號
 *  @param autodms_order_number AutoDMS訂單編號
 *  @param statuses 審核狀態們
 *  @param is_dispatched 車管是否已配車
 *  @param stop_dispatch 是否暫停配對
 *  @param is_release_check 是否確認放行
 *  @param is_licensed_check 是否確認領牌
 *  @param is_accounting_check 財務是否確認
 *  @param is_invoice_check 是否發票確認
 *  @param page 頁碼
 *  @param num_per_page 一頁幾筆
 * 
 */
export interface OrderListOwnParams {
    order_number_start?: string,
    order_number_end?: string,
    allotment_time_start?: string,
    allotment_time_end?: string,
    first_submit_time_start?: string,
    first_submit_time_end?: string,
    order_id?: string,
    autodms_order_number?: string,
    statuses: string[],
    is_dispatched?: string,
    stop_dispatch?: string,
    is_release_check?: string,
    is_licensed_check?: string,
    is_accounting_check?: string,
    is_invoice_check?: string,
    page: number,
    num_per_page: number,
}

/**訂單列表(自己的) (回傳)
 *  @description 訂單列表(自己的) (回傳)
 *  @param custody_user_id 保管人(使用者)ID
 *  @param custody_user_name 保管人(使用者)名稱
 *  @param allotment_time 領取日
 *  @param audit_status 稽核狀態
 *  @param audit_note 稽核備註
 *  @param audit_time 稽核時間
 *  @param custody_unit_id 保官單位ID
 *  @param custody_unit_name 保官單位名稱
 *  @param custody_user_id 保官人ID
 *  @param custody_user_name 保官人
 *  @param order_id 
 *  @param order_number 訂單號碼
 *  @param abnormal_return_status 異常狀態
 * 
 */
export interface OrderListOwnResItem {
    abnormal_return_note: string;
    abnormal_return_status: string;
    abnormal_return_time: string;
    accounting_check_time: string;
    allotment_time: string;
    audit_note: string;
    audit_status: string;
    audit_time: string;
    autodms_order_number: string;
    contract_date: string;
    custody_unit_id: string;
    custody_unit_name: string;
    custody_user_id: string;
    custody_user_name: string;
    dispatch_car_time: string;
    first_audit_time: string;
    first_submit_time: string;
    invoice_check_time: string;
    is_accounting_check: string;
    is_dispatched: string;
    is_invoice_check: string;
    is_licensed_check: string;
    is_release_check: string;
    isabnormal: string;
    licensed_check_endorse_user_id: string;
    licensed_check_time: string;
    order_allotment_id: number;
    order_id: string;
    order_number: string;
    order_status: string;
    release_check_endorse_user_id: string;
    release_check_time: string;
    stop_dispatch: string;
    upd_time: string;
    user_cre_time: string;
}

/** @description 訂單列表(自己的)*/
export const OrderListOwn =
    async (obj: OrderListOwnParams): Promise<ResultObj<OrderListOwnResItem[]>> => await allFetch('Order/OrderListOwn', obj);


/**訂單細項 (參數)
 *  @description 訂單細項 (參數)
 *  @param order_id 訂單系統編號
 */
export interface OrderDetailParams {
    order_id: string,
}

/** @description 訂單細項 (回傳) */
export interface OrderDetailResItem {
    dt: {
        PR_bonus_price: number;
        PR_bonus_user_id: string;
        SIDO_no: string;
        abnormal_sale_type: string;
        accounting_check_time: string;
        actual_actual_condition_sum: number;
        actual_difference_price: number;
        actual_pay_price: number;
        autodms_order_number: string;
        car_type: string;
        car_type_price: number;
        cash_nondeductible: number;
        cash_subsidy_deductible: number;
        cash_subsidy_nondeductible: number;
        ce_id: number;
        ci_id: number;
        company_rule: number;
        component_own_expense_sum: number;
        component_price_sum: number;
        component_subsidy_deductible_sum: number;
        component_subsidy_nondeductible_sum: number;
        contract_date: string;
        cre_time: string;
        cs_id: string;
        ct_id: number;
        ctep_id: number;
        ctf_id: number;
        ctfp_id: number;
        ctip_id: number;
        cus_agree_time: string;
        custody_unit_id: string;
        custody_user_cre_time: string;
        custody_user_id: string;
        custody_user_name: string;
        delivery_date: string;
        deposit_sum: number;
        dispatch_car_time: string;
        exterior_code: string;
        exterior_color: string;
        exterior_price: number;
        extraction_date: string;
        first_audit_time: string;
        first_submit_time: string;
        format_code: string;
        format_name: string;
        insurance_company: string;
        insurance_price: number;
        interior_code: string;
        interior_color: string;
        interior_price: number;
        invoice_check_time: string;
        /* 發票總金額*/
        invoice_price_sum: number;
        is_accounting_check: string;
        is_car_limit: string;
        is_dispatched: string;
        is_invoice_check: string;
        is_licensed_check: string;
        is_release_check: string;
        is_self_licensed: string;
        license_plate: string;
        licensed_check_endorse_user_id: string;
        licensed_check_endorse_user_name: string;
        licensed_check_time: string;
        licensed_date: string;
        licenser_address_contact: string;
        licenser_birthday: string;
        licenser_cellphone: string;
        licenser_customer_name: string;
        licenser_email: string;
        licenser_identity_number: string;
        licenser_is_orderer: string;
        loan_agency: string;
        loan_bank_insurance_date: string;
        loan_bank_predict_price: number;
        loan_company_subsidy_price: number;
        loan_predict_subsidy_price: number;
        /* 銷顧獎金補貸款補貼息 */
        sales_advisor_loan_subsidy: number;
        note: string;
        order_id: string;
        order_number: string;
        order_status: string;
        orderer_address_contact: string;
        orderer_birthday: string;
        orderer_cellphone: string;
        orderer_customer_name: string;
        orderer_email: string;
        orderer_identity_number: string;
        over_discount_note: string;
        over_discount_price: number;
        over_discount_price_sum: number;
        pc_cre_time: string;
        potential_customer_address_contact: string;
        potential_customer_cellphone: string;
        potential_customer_chance_number: string;
        potential_customer_id: string;
        potential_customer_level: string;
        potential_customer_level_name: string;
        potential_customer_name: string;
        potential_customer_source: string;
        potential_customer_source_name: string;
        potential_is_orderer: string;
        predict_actual_condition_sum: number;
        predict_balance: number;
        predict_delivery_date: string;
        predict_difference_price: number;
        predict_licensed_date: string;
        /* 應收總金額 */
        receivable_amount: number;
        /* 預計繳入金額+銷售佣金 */
        total_amount: number;
        /** 自填 */
        predict_pay_price: number;
        promotion_condition_sum: number;
        release_check_endorse_user_id: string;
        release_check_endorse_user_name: string;
        release_check_time: string;
        stop_dispatch: string;
        store_department: string;
        /** 系統計算 */
        system_pay_price: number;
        upd_time: string;
        user_address_contact: string;
        user_birthday: string;
        user_cellphone: string;
        user_customer_name: string;
        user_email: string;
        user_identity_number: string;
        user_is_orderer: string;
        vin_no: string;
        year: string;
        year_age: number;
        /** 全款日(調整過的) */
        final_payment_time: string;
        /** 全款日 */
        final_payment_check_time: string;
        /* 預計交車日期 */
        predict_recovery_date: string;
        /*  交車備註 */
        delivery_note: string;
    }[],
    dt_order_components: (OrderCarComponentParams & {
        occ_id: number, // 配件ID
    })[],
    dt_order_invoice: [],
    dt_order_payment: {
        abnormal_sale_type: string
        category: string
        check_expired_date: string;
        check_number: string;
        check_pay_bank: string;
        check_price: string;
        check_receive_bank: string;
        check_receive_date: string;
        commodity_id: string
        cs_id: string
        csc_id: string
        csd_id: string
        csm_id: string
        deductible: string
        documet_source: string
        innertransfer_out_bank: string;
        innertransfer_out_date: string;
        innertransfer_out_method: string;
        innertransfer_out_price: string;
        innertransfer_summon_code: string;
        /** 使否為會計入金 */
        is_accounting: string;
        isdeposit: string;
        label_big: string
        loan_agency: string;
        loan_bank_insurance_date: string;
        loan_bank_predict_price: string;
        loan_predict_subsidy_price: string;
        loan_company_subsidy_price: string;
        loan_tenure: string;
        name: string;
        note: string;
        ocsd_id: string
        op_id: string;
        order_id: string;
        overcharge: string;
        payment: string;
        price: string
        swipe_handling_fee: string;
        swipe_in_account: string;
        swipe_in_bank: string;
        swipe_price: string;
        transfer_in_account: string;
        transfer_in_bank: string;
        transfer_in_date: string;
        transfer_in_price: string;
        transfer_out_account: string;
        transfer_out_bank: string;
        type: string
        uc_id: string
        upd_time: string;
        upd_userid: string;
        user_cre_time: string;
        username: string;
        sales_advisor_loan_subsidy: string;
    }[],
    dt_order_subsidy: [],
    dt_order_insurance: {
        insurance_company_code: string;
        insurance_company_id: string;
        insurance_company_name: string;
        insurance_id: string;
        insurance_name: string;
        insurance_type: string;
        insurance_type_name: string;
        note: string;
        oi_id: string;
        order_id: string;
    }[],
}

/** @description 訂單細項 */
export const OrderDetail =
    async (obj: OrderDetailParams = {
        order_id: '',
    }): Promise<ResultObj<OrderDetailResItem>> => await allFetch('Order/OrderDetail', obj);










// -----------------------------------------------------------------------------------------------------

/** 訂單受定修改 (參數)
 *  @param order_id 訂單系統編號 (必)
 *  @param autodms_order_number AutoDMS訂單編號
 *  @param order_potential_customer 訂單潛客部分
 *  @param order_car 訂單車型部分
 *  @param order_components 訂單配件部分
 *  @param order_payment 訂單入金部分
 *  @param order_loan 訂單貸款部分
 */
export interface OrderSubscribeUpdateParams {
    order_id: string,
    autodms_order_number: string,
    order_potential_customer: PotentialCustomerUpdateFromOrderParams,
    order_car: OrderCarParams,
    order_components: OrderCarComponentParams[],
    order_payment: OrderPayment,
    order_loan: OrderLoan,
    order_insurance: OrderInsurance,
    predict_pay_price?: number
}

/** 訂單受定修改 */
export const OrderSubscribeUpdate =
    async (obj: OrderSubscribeUpdateParams = {
        order_id: '',
        autodms_order_number: '',
        order_potential_customer: {
            potential_customer_name: '',
            chance_number: '',
            source: '',
            level: '',
            cellphone: '',
            address_contact: '',
            potential_is_orderer: '',
            potential_customer_id: '',
            orderer_customer_name: '',
            orderer_identity_number: '',
            orderer_cellphone: '',
            orderer_address_contact: '',
            orderer_birthday: '',
            orderer_email: '',
        },
        order_car: {
            is_self_licensed: '',
            is_car_limit: '',
            cs_id: '',
            abnormal_sale_type: '',
            note: '',
            PR_bonus_user_id: '',
            PR_bonus_price: '',
            ctfp_id: '',
            ctep_id: '',
            ctip_id: '',
            year: '',
            year_age: ''
        },
        order_components: [],
        order_payment: {
            company_rule: '',
            order_payment_details: []
        },
        order_loan: {
            loan_agency: '',
            loan_bank_insurance_date: '',
            loan_bank_predict_price: ''
        },
        order_insurance: {
            insurance_id: '',
            insurance_name: '',
            insurance_price: 0,
            insurance_type: '',
            insurance_type_name: '',
            insurance_company_id: '',
            insurance_company_code: '',
            insurance_company_name: '',
            note: ''
        },
        predict_pay_price: 0
    }): Promise<ResultObj> => await allFetch('Order/OrderSubscribeUpdate', obj);

/** 訂單保險修改 (參數)
 * @param oi_id 訂單系統編號
 * @param order_id 訂單系統編號
 * @param order_insurance 訂單保險部分
 */
export interface OrderInsuranceUpdateParams {
    oi_id: string;
    order_id: string;
    order_insurance?: OrderInsurance;
}

/** 訂單保險修改 */
export const OrderInsuranceUpdate =
    async (obj: OrderInsuranceUpdateParams): Promise<ResultObj> => await allFetch('Order/OrderInsuranceUpdate', obj);


/**訂單受定修改 車 (參數)
 *  @description 訂單受定修改 車 (參數)
 *  @param is_self_licensed 是否自領牌(必)
 *  @param is_car_limit 是否限定車(必)
 *  @param cs_id 車流水號
 *  @param abnormal_sale_type 異常銷售種類(必)
 *  @param note 銷顧備註
 *  @param PR_bonus_user_id 公關車交車獎金領受人
 *  @param PR_bonus_price 公關車交車獎金
 *  @param ctfp_id 車型規格定價流水號(必)
 *  @param ctep_id 車型外裝加價流水號(必)
 *  @param ctip_id 車型內裝加價流水號(必)
 *  @param year 車型內裝加價流水號(必)
 *  @param year_age 車型內裝加價流水號(必)
 */
export interface OrderCarParams {
    is_self_licensed: string;
    is_car_limit: string;
    cs_id: string;
    abnormal_sale_type: string;
    note: string;
    PR_bonus_user_id: string;
    PR_bonus_price: string;
    ctfp_id: string;
    ctep_id: string;
    ctip_id: string;
    year: string;
    year_age: string;
}


/**訂單受定修改 配件 (參數)
 *  @description 訂單受定修改 配件 (參數)
 *  @param stock_id 庫存流水號
 *  @param commodity_id 商品流水號(必)
 *  @param uc_id 單位換算流水號(必)
 *  @param ccad_id_1 自訂屬性細項流水號1(必)
 *  @param ccad_id_2 自訂屬性細項流水號2(必)
 *  @param need_calc_stock 是否計算庫存(必)
 *  @param component_type 配件類別
 *  @param component_name 配件名稱(必)
 *  @param price 單價
 *  @param count 數量
 */
export interface OrderCarComponentParams {
    stock_id: string;
    commodity_id: string;
    uc_id: string;
    ccad_id_1: string;
    ccad_id_2: string;
    need_calc_stock: string;
    component_type: string;
    component_name: string;
    price: string;
    count: string;
}

/** 訂單受定修改 潛客資訊 (參數) 
*  @description 訂單受定修改 潛客資訊 (參數) 
*  @param potential_customer_name 客戶名稱(必)
*  @param chance_number 機會編號(必)
*  @param source 資料來源
*  @param level 等級
*  @param cellphone 行動電話
*  @param address_contact 聯絡地址
*  @param potential_is_orderer 潛客是否購買人
*  @param potential_customer_id 潛客流水號
*  @param orderer_customer_name 訂購人名稱
*  @param orderer_identity_number 訂購人身分證
*  @param orderer_cellphone 訂購人電話
*  @param orderer_address_contact 訂購人地址
*  @param orderer_birthday 訂購人生日
*  @param orderer_email 訂購人信箱
*/
export interface PotentialCustomerUpdateFromOrderParams {
    potential_customer_name: string,
    chance_number: string,
    source: string,
    level: string,
    cellphone: string,
    address_contact: string,
    potential_is_orderer: string,
    potential_customer_id: string,
    orderer_customer_name: string,
    orderer_identity_number: string,
    orderer_cellphone: string,
    orderer_address_contact: string,
    orderer_birthday: string,
    orderer_email: string,
    identity_number?: string,
    email?: string,
    birthday?: string,
}

/**訂單受定修改 入金 (大參數)
 *  @description 訂單受定修改 入金 (大參數)
 *  @param company_rule 公司規範(最少訂金)
 *  @param order_payment_details 訂單入金細項
 */
export interface OrderPayment {
    company_rule: string;
    order_payment_details: OrderPaymentDetail[]
}

/**訂單入金細項
 *  @description 訂單入金細項
 * @param isdeposit 是否訂金
 * @param payment 付款方式
 * @param transfer_out_bank 匯款轉出銀行
 * @param transfer_out_account 匯款轉出帳號
 * @param transfer_in_bank 匯款轉入銀行
 * @param transfer_in_account 匯款轉入帳號
 * @param transfer_in_date 匯款轉入日期
 * @param transfer_in_price 匯款入金金額
 * @param check_pay_bank 支票付款銀行
 * @param check_number 支票票號
 * @param check_receive_bank 支票貸收銀行
 * @param check_receive_date 支票貸收日期
 * @param check_expired_date 支票到期日
 * @param check_price 支票入金金額
 * @param swipe_in_bank 刷卡轉入銀行
 * @param swipe_in_account 刷卡轉入帳號
 * @param swipe_price 刷卡入金金額
 * @param swipe_handling_fee 刷卡手續費
 * @param innertransfer_out_bank 內轉轉出銀行
 * @param innertransfer_out_date 內轉轉出日期
 * @param innertransfer_out_price 內轉轉出金額
 * @param innertransfer_out_method 內轉轉出方式
 * @param innertransfer_summon_code 內轉轉出傳票號碼
 * @param note 備註
 * @param overcharge 溢收
 * @param loan_agency 貸款機構
 * @param loan_bank_insurance_date 貸款銀行預計對保日期
 * @param loan_bank_predict_price 貸款預計金額
 * @param loan_predict_subsidy_price 預估貸款補貼息
 * @param loan_tenure 貸款期數 
 * @param loan_company_subsidy_price 銷顧獎金補貸款補貼息
 */
export interface OrderPaymentDetail {
    isdeposit?: string;
    payment?: string;
    transfer_out_bank?: string;
    transfer_out_account?: string;
    transfer_in_bank?: string;
    transfer_in_account?: string;
    transfer_in_date?: string;
    transfer_in_price?: string;
    check_pay_bank?: string;
    check_number?: string;
    check_receive_bank?: string;
    check_receive_date?: string;
    check_expired_date?: string;
    check_price?: string;
    swipe_in_bank?: string;
    swipe_in_account?: string;
    swipe_price?: string;
    swipe_handling_fee?: string;
    innertransfer_out_bank?: string;
    innertransfer_out_date?: string;
    innertransfer_out_price?: string;
    innertransfer_out_method?: string;
    innertransfer_summon_code?: string;
    note?: string;
    overcharge?: string;
    loan_agency?: string;
    /**貸款銀行預計對保日期 */
    loan_bank_insurance_date?: string;
    /**貸款預計金額 */
    loan_bank_predict_price?: string;
    /**預估貸款補貼息 */
    loan_predict_subsidy_price?: string;
    /**貸款公司補助補貼息 */
    loan_company_subsidy_price?: string;
    loan_tenure?: string;
    sales_advisor_loan_subsidy?: string;
}

/** 訂單保險項目
 * @param insurance_id 保險流水號
 * @param insurance_name 保險名稱
 * @param insurance_price 保險報價金額
 * @param insurance_type 保險種類
 * @param insurance_type_name 保險種類名稱
 * @param insurance_company_id 保險公司流水號
 * @param insurance_company_code 保險公司代號
 * @param insurance_company_name 保險公司名稱
 * @param note 備註
 */
export interface OrderInsurance {
    insurance_id: string,
    insurance_name: string,
    insurance_price: number,
    insurance_type: string,
    insurance_type_name: string,
    insurance_company_id: string,
    insurance_company_code: string,
    insurance_company_name: string,
    note: string
}

/**訂單受定修改 貸款 (參數)
 *  @description 訂單受定修改 貸款 (參數)
 *  @param loan_agency 貸款機構
 *  @param loan_bank_insurance_date 貸款銀行預計對保日期
 *  @param loan_bank_predict_price 貸款預計金額
 *  @param loan_predict_subsidy_price 預估貸款補貼息
 *  @param loan_company_subsidy_price 公司補助貸款補貼息
 */
export interface OrderLoan {
    loan_agency: string;
    loan_bank_insurance_date?: string;
    loan_bank_predict_price?: string;
    loan_predict_subsidy_price?: string;
    loan_company_subsidy_price?: string;
}


/**訂單計算補助(沒更新訂單) (參數)
 *  @description 訂單計算補助(沒更新訂單) (參數)
 *  @param ct_id 車型流水號
 *  @param ctf_id 車型規格流水號
 *  @param year 年式
 *  @param year_age 年份
 *  @param cs_id 車流水號
 *  @param loan_bank_predict_price 貸款預計金額
 *  @param car_components 配件們
 *  @param licensed_date 領牌日期
 *  @param abnormal_sale_type 異常銷售種類
 */
export interface OrderCalculateSubsidyBeforeUpdateParams {
    order_id: string;
    ct_id: string;
    ctf_id: string;
    year: string;
    year_age: string;
    cs_id: string;
    loan_bank_predict_price: string;
    car_components: OrderCarComponentParams[];
    licensed_date: string;
    abnormal_sale_type: string;
    insurance_type: string;
}

/**@description 訂單計算補助(沒更新訂單) (回傳) */
export interface OrderCalculateSubsidyBeforeUpdateResItem {
    cash_subsidy_deductible: string;
    cash_subsidy_nondeductible: string;
    component_own_expense_sum: string;
    component_subsidy_deductible_sum: string;
    component_subsidy_nondeductible_sum: string;
    list: [];
    loan_company_subsidy_price: string;
    loop_count: string;
}

/**@description 訂單計算補助(沒更新訂單) */
export const OrderCalculateSubsidyBeforeUpdate =
    async (obj: OrderCalculateSubsidyBeforeUpdateParams = {
        order_id: '',
        ct_id: '',
        ctf_id: '',
        year: '',
        year_age: '',
        cs_id: '',
        loan_bank_predict_price: '',
        car_components: [],
        licensed_date: '',
        abnormal_sale_type: '',
        insurance_type: ''
    }): Promise<ResultObj<OrderCalculateSubsidyBeforeUpdateResItem>> => await allFetch('Order/OrderCalculateSubsidyBeforeUpdate', obj);




/**訂單超折申請 (參數)
*  @description 訂單超折申請 (參數)
*  @param order_id 訂單系統編號
*  @param over_discount_price 超折申請
*  @param PR_bonus_user_id 公關車交車獎金領受人
*  @param PR_bonus_price 公關車交車獎金
*  @param over_discount_note 超折備註
*/
export interface OrderOverDiscountSubmitParams {
    order_id: string;
    over_discount_price: string;
    PR_bonus_user_id: string;
    PR_bonus_price: string;
    over_discount_note: string;
}

/**@description  訂單超折申請 (回傳)*/
export interface OrderOverDiscountSubmitResItem {
    cash_subsidy_deductible: string;
    cash_subsidy_nondeductible: string;
    component_own_expense_sum: string;
    component_subsidy_deductible_sum: string;
    component_subsidy_nondeductible_sum: string;
    list: [];
    loan_company_subsidy_price: string;
    loop_count: string;
}

/**@description  訂單超折申請 */
export const OrderOverDiscountSubmit =
    async (obj: OrderOverDiscountSubmitParams = {
        order_id: '',
        over_discount_price: '',
        PR_bonus_user_id: '',
        PR_bonus_price: '',
        over_discount_note: ''

    }): Promise<ResultObj<OrderOverDiscountSubmitResItem>> => await allFetch('Order/OrderOverDiscountSubmit', obj);



/**訂單修改預計領牌日期 (參數)
*  @description 訂單受訂送審(參數)
*  @param order_id 訂單系統編號
*  @param predict_licensed_date 預計領牌時間(14)
*/
export interface OrderUpdateLicensedDateParams {
    order_id: string;
    predict_licensed_date: string
}

/**@description  訂單修改預計領牌日期*/
export const OrderUpdateLicensedDate =
    async (obj: OrderUpdateLicensedDateParams = {
        order_id: '',
        predict_licensed_date: ''

    }): Promise<ResultObj> => await allFetch('Order/OrderUpdateLicensedDate', obj);




/**訂單車型庫存檢查 (參數)
*  @description 訂單車型庫存檢查 (參數)
*  @param ctfp_id 車型規格定價流水號(必)
*  @param ctep_id 車型外裝加價流水號(必)
*  @param ctip_id 車型內裝加價流水號(必)
*  @param order_id 訂單系統編號
*/

export interface OrderCarStockSearchParams {
    ctfp_id: string;
    ctep_id: string
    ctip_id: string
    order_id: string
}

/**@description 訂單車型庫存檢查 (回傳) */
export interface OrderCarStockSearchResItem {
}

/**@description  訂單車型庫存檢查*/
export const OrderCarStockSearch =
    async (obj: OrderCarStockSearchParams = {
        ctfp_id: '',
        ctep_id: '',
        ctip_id: '',
        order_id: '',

    }): Promise<ResultObj<OrderCarStockSearchResItem>> => await allFetch('Order/OrderCarStockSearch', obj);



// -----------------------------------
/**訂單受訂送審 (參數)
*  @description 訂單受訂送審 (參數)
*  @param order_id 訂單系統編號
*/
export interface OrderSubscribeSubmitParams {
    order_id: string;
}
export const OrderSubscribeSubmit =
    async (obj: OrderSubscribeSubmitParams = {
        order_id: '',

    }): Promise<ResultObj> => await allFetch('Order/OrderSubscribeSubmit', obj);

// ------------------------------------

/**訂單列表 (參數)
 *  @description 訂單列表(參數)
 *  @param order_number_start 訂單編號起
 *  @param order_number_end 訂單編號迄
 *  @param position_id 據點流水號
 *  @param allotment_time_start 領取日期起
 *  @param allotment_time_end 領取日期迄
 *  @param first_submit_time_start 申請日期起
 *  @param first_submit_time_end 申請日期迄
 *  @param dispatch_car_time_start 配車時間起
 *  @param dispatch_car_time_end 配車時間迄
 *  @param custody_unit_id 保管單位(據點流水號)
 *  @param custody_unit_ids 保管人(帳號編號)們
 *  @param order_id 訂單系統編號
 *  @param autodms_order_number AutoDMS訂單編號 * 
 *  @param statuses 審核狀態們
 *  @param is_dispatched 車管是否已配車
 *  @param stop_dispatch 是否暫停配對
 *  @param is_release_check 是否確認放行
 *  @param is_licensed_check 是否確認領牌
 *  @param is_accounting_check 財務是否確認
 *  @param is_invoice_check 是否發票確認
 *  @param is_final_payment_check 是否全款日確認
 *  @param my_turn 是否輪到我審
 *  @param page 頁碼
 *  @param num_per_page 一頁幾筆 * 
 */
export interface OrderListParams {
    order_number_start?: string;
    order_number_end?: string;
    position_id?: string;
    allotment_time_start?: string;
    first_submit_time_start?: string;
    first_submit_time_end?: string;
    dispatch_car_time_start?: string;
    dispatch_car_time_end?: string;
    allotment_time_end?: string;
    custody_unit_id?: string;
    custody_user_ids?: string[];
    order_id?: string;
    autodms_order_number?: string;
    statuses: string[];
    is_dispatched?: string;
    stop_dispatch?: string;
    is_release_check?: string;
    is_licensed_check?: string;
    is_accounting_check?: string;
    is_invoice_check?: string;
    is_final_payment_check?: string;
    my_turn?: string;
    page: number,
    num_per_page: number,
}

/** @description 訂單列表(回傳) */
export interface OrderListResItem {
    abnormal_return_note: string;
    abnormal_return_status: string;
    abnormal_return_time: string;
    accounting_check_time: string;
    allotment_time: string;
    audit_level: string;
    audit_level_ul_id: string; // JSON string representation of audit levels
    audit_note: string;
    audit_status: string;
    audit_time: string;
    autodms_order_number: string;
    contract_date: string;
    custody_unit_id: string;
    custody_unit_name: string;
    custody_user_id: string;
    custody_user_name: string;
    customer_cre_time: string;
    dispatch_car_time: string;
    first_audit_time: string;
    first_submit_time: string;
    invoice_check_time: string;
    is_accounting_check: string;
    is_dispatched: string;
    is_invoice_check: string;
    is_licensed_check: string;
    is_release_check: string;
    isabnormal: string;
    licensed_check_endorse_user_id: string;
    licensed_check_time: string;
    order_allotment_id: number;
    order_id: string;
    order_number: string;
    order_status: string;
    potential_customer_name: string;
    release_check_endorse_user_id: string;
    release_check_time: string;
    stop_dispatch: string;
    user_cre_time: string;
    /** 全款日(調整過的) */
    final_payment_time: string;
    /** 全款日 */
    final_payment_check_time: string;
}

/** @description 訂單列表 */
export const OrderList = async (obj: OrderListParams): Promise<ResultObj<OrderListResItem[]>> => await allFetch('Order/OrderList', obj);


/**審核訂單受訂 (參數)
 * @description 審核訂單受訂 (參數)
 * @param order_id 訂單系統編號
 * @param audit_status 稽核狀態
 * @param audit_note 稽核備註
 */
export interface OrderSubscribeAuditParams {
    order_id: string,
    status: string,
    note: string,
}

/** @description 審核訂單受訂 */
export const OrderSubscribeAudit =
    async (obj: OrderSubscribeAuditParams = {
        order_id: '',
        status: '',
        note: ''
    }): Promise<ResultObj> => await allFetch('Order/OrderSubscribeAudit', obj);



// ---------------------------------------------


/**訂單暫停配對 或取消 (參數)
 * @description 訂單暫停配對 或取消 (參數)
 * @param order_id 訂單系統編號
 * @param stop_dispatch 是否暫停配對
 */
export interface OrderStopDispatchParams {
    order_id: string,
    stop_dispatch: string,
}

/** @description 訂單暫停配對 或取消 */
export const OrderStopDispatch =
    async (obj: OrderStopDispatchParams = {
        order_id: '',
        stop_dispatch: '',
    }): Promise<ResultObj> => await allFetch('Order/OrderStopDispatch', obj);


/**訂單配車查詢(查可以配的車) (參數)
* @description 訂單配車查詢(查可以配的車) (參數)
* @param order_id 訂單系統編號
*/
export interface OrderDispatchCarSearchParams {
    order_id: string,
}

/** @description 訂單配車查詢(查可以配的車) (回傳) */
export interface OrderDispatchCarSearchResItem {
    SIDO_no: string;
    cs_id: string;
    ctep_id: string;
    ctfp_id: string;
    ctip_id: string;
    leave_factory_date: string;
    store_department: string;
    vin_no: string;
}

/** @description 訂單配車查詢(查可以配的車) */
export const OrderDispatchCarSearch =
    async (obj: OrderDispatchCarSearchParams = {
        order_id: ''
    }): Promise<ResultObj<OrderDispatchCarSearchResItem[]>> => await allFetch('Order/OrderDispatchCarSearch', obj);


/**查補助限定車 (參數)
* @description 查補助限定車 (參數)
* @param order_id 訂單系統編號
* @param ct_id 車型流水號
* @param ctf_id 車型規格對照流水號
* @param year 年式
* @param year_age 年份
* @param licensed_date 領牌日期
* @param abnormal_sale_type 異常銷售種類
*/
export interface OrderSubsidyCarSearchParams {
    order_id: string,
    ct_id: string,
    ctf_id: string,
    year: string,
    year_age: string,
    licensed_date?: string,
    abnormal_sale_type?: string,
}
// export interface OrderDispatchCarSearchResItem {
//     SIDO_no: string;
//     cs_id: string;
//     ctep_id: string;
//     ctfp_id: string;
//     ctip_id: string;
//     leave_factory_date: string;
//     store_department: string;
//     vin_no: string;
// }

/** @description 查補助限定車 */
export const OrderSubsidyCarSearch =
    async (obj: OrderSubsidyCarSearchParams): Promise<ResultObj<OrderDispatchCarSearchResItem[]>> => await allFetch('Order/OrderSubsidyCarSearch', obj);



/**訂單配車 或取消 (參數)
 * @description 訂單配車 或取消 (參數)
 * @param order_id 訂單系統編號
 * @param cs_id 車庫存流水號(取消即給'')
 */
export interface OrderDispatchCarParams {
    order_id: string,
    cs_id: string,
}

/** @description 訂單配車 或取消 (回傳) */
export interface OrderDispatchCarResItem {
    SIDO_no: string,
    vin_no: string,
    cs_id: string,
    dispatch_car_time: string,
    is_dispatched: string,
}

/** @description 訂單配車 或取消 */
export const OrderDispatchCar =
    async (obj: OrderDispatchCarParams = {
        order_id: '',
        cs_id: '',
    }): Promise<ResultObj<OrderDispatchCarResItem[]>> => await allFetch('Order/OrderDispatchCar', obj);


/**訂單會計入金新增 (參數)
*  @description 訂單會計入金新增 (參數)
*  @param order_id 訂單系統編號
*  @param order_payment_detail 訂單入金細項
*/
export interface OrderAccountingPaymentCreateParams {
    order_id: string;
    order_payment_detail: OrderPaymentDetail
}

/** @description 訂單會計入金新增 */
export const OrderAccountingPaymentCreate =
    async (obj: OrderAccountingPaymentCreateParams): Promise<ResultObj<OrderDetailResItem>> => await allFetch('Order/OrderAccountingPaymentCreate', obj);


/**訂單會計入金修改 (參數)
*  @description 訂單會計入金修改 (參數)
*  @param op_id 訂單付款記錄流水號
*  @param order_id 訂單系統編號
*  @param order_payment_detail 訂單入金細項
*/
export interface OrderAccountingPaymentUpdateParams {
    op_id: string;
    order_id: string;
    order_payment_detail: OrderPaymentDetail
}

/** @description 訂單會計入金修改 */
export const OrderAccountingPaymentUpdate =
    async (obj: OrderAccountingPaymentUpdateParams): Promise<ResultObj<OrderDetailResItem>> => await allFetch('Order/OrderAccountingPaymentUpdate', obj);


/**訂單會計入金刪除 (參數)
*  @description 訂單會計入金刪除 (參數)
*  @param op_id 訂單付款記錄流水號
*  @param order_id 訂單系統編號
*/
export interface OrderAccountingPaymentDeleteParams {
    op_id: string;
    order_id: string;
}

/** @description 訂單會計入金刪除 */
export const OrderAccountingPaymentDelete =
    async (obj: OrderAccountingPaymentDeleteParams = {
        op_id: '',
        order_id: '',
    }): Promise<ResultObj<OrderDetailResItem>> => await allFetch('Order/OrderAccountingPaymentDelete', obj);


/** 訂單會計確認 (參數)
*  @description 訂單會計確認 (參數)
*  @param order_id 訂單系統編號
*/
export interface OrderAccountingPaymentCheckParams {
    order_id: string;
    accounting_check_time: string;
}

/** @description 訂單會計確認 */
export const OrderAccountingPaymentCheck =
    async (obj: OrderAccountingPaymentCheckParams = {
        order_id: '',
        accounting_check_time: '',
    }): Promise<ResultObj> => await allFetch('Order/OrderAccountingPaymentCheck', obj);


/**訂單發票確認 (參數)
*  @description 訂單發票確認 (參數)
*  @param order_id 訂單系統編號
*/
export interface OrderInvoiceCheckParams {
    order_id: string;
}

/** @description 訂單發票確認 */
export const OrderInvoiceCheck =
    async (obj: OrderInvoiceCheckParams = {
        order_id: '',
    }): Promise<ResultObj> => await allFetch('Order/OrderInvoiceCheck', obj);


/**訂單修改發票 (參數)
*  @description 訂單修改發票 (參數)
*  @param order_id 訂單系統編號
*  @param order_invoice_details 訂單發票細項
*/
export interface OrderInvoiceUpdateParams {
    order_id: string;
    order_invoice_details: OrderInvoiceDetail[]
}

/** @description 訂單修改發票 */
export const OrderInvoiceUpdate =
    async (obj: OrderInvoiceUpdateParams = {
        order_id: '',
        order_invoice_details: []
    }): Promise<ResultObj> => await allFetch('Order/OrderInvoiceUpdate', obj);

/** @description 訂單發票細項 */
export interface OrderInvoiceDetail {
    invoice_price: string,
    invoice_number: string,
    invoice_date: string
}

/** 全款日確認 (參數)
*  @param order_id 訂單系統編號
*/
export interface OrderFinalPaymentDateCheckParams {
    order_id: string;
}

/** 全款日確認後再調整 (回傳)*/
export interface OrderFinalPaymentDateUpdateResItem {
    final_payment_check_time: string;
    final_payment_time: string,
}

/** 全款日確認 */
export const OrderFinalPaymentDateCheck =
    async (obj: OrderFinalPaymentDateCheckParams = {
        order_id: '',
    }): Promise<ResultObj<OrderFinalPaymentDateUpdateResItem[]>> => await allFetch('Order/OrderFinalPaymentDateCheck', obj);

/** 全款日確認後再調整 (參數)
*  @param order_id 訂單系統編號
*  @param final_payment_time 全款日
*/
export interface OrderFinalPaymentDateUpdateParams {
    order_id: string;
    final_payment_time?: string,
}

/** 全款日確認後再調整 */
export const OrderFinalPaymentDateUpdate =
    async (obj: OrderFinalPaymentDateUpdateParams = {
        order_id: '',
        final_payment_time: '',
    }): Promise<ResultObj<OrderFinalPaymentDateUpdateResItem[]>> => await allFetch('Order/OrderFinalPaymentDateUpdate', obj);


/**訂單修改領牌人使用人資訊 (參數)
*  @description 訂單修改領牌人使用人資訊 (參數)
*  @param order_id 訂單系統編號
*  @param licenser_is_orderer 領牌人是否購買人
*  @param licenser_customer_name 領牌人名稱
*  @param licenser_identity_number 領牌人身分證
*  @param licenser_cellphone 領牌人電話
*  @param licenser_address_contact 領牌人地址
*  @param licenser_birthday 領牌人生日
*  @param licenser_email 領牌人信箱
*  @param user_is_orderer 使用人是否購買人
*  @param user_customer_name 使用人名稱
*  @param user_identity_number 使用人身分證
*  @param user_cellphone 使用人電話
*  @param user_address_contact 使用人地址
*  @param user_birthday 使用人生日
*  @param user_email 使用人信箱
*/
export interface OrderReleaseUpdateCustomerParams {
    order_id: string,
    licenser_is_orderer: string,
    licenser_customer_name: string,
    licenser_identity_number: string,
    licenser_cellphone: string,
    licenser_address_contact: string,
    licenser_birthday: string,
    licenser_email: string,
    user_is_orderer: string,
    user_customer_name: string,
    user_identity_number: string,
    user_cellphone: string,
    user_address_contact: string,
    user_birthday: string,
    user_email: string
}

/** @description  訂單修改領牌人使用人資訊 */
export const OrderReleaseUpdateCustomer =
    async (obj: OrderReleaseUpdateCustomerParams = {
        order_id: '',
        licenser_is_orderer: '',
        licenser_customer_name: '',
        licenser_identity_number: '',
        licenser_cellphone: '',
        licenser_address_contact: '',
        licenser_birthday: '',
        licenser_email: '',
        user_is_orderer: '',
        user_customer_name: '',
        user_identity_number: '',
        user_cellphone: '',
        user_address_contact: '',
        user_birthday: '',
        user_email: ''
    }): Promise<ResultObj> => await allFetch('Order/OrderReleaseUpdateCustomer', obj);

/** 訂單放行日期們修改 (參數)
*  @description 訂單放行日期們修改 (參數)
*  @param order_id 訂單系統編號
*  @param extraction_date 提車日期
*  @param predict_delivery_date 預計交車日期
*  @param delivery_date 交車日期
*/
export interface OrderReleaseUpdateDateParams {
    order_id: string,
    extraction_date: string,
    predict_delivery_date: string,
    delivery_date: string,

}

/** @description  訂單放行日期們修改 */
export const OrderReleaseUpdateDate =
    async (obj: OrderReleaseUpdateDateParams = {
        order_id: '',
        extraction_date: '',
        predict_delivery_date: '',
        delivery_date: '',

    }): Promise<ResultObj> => await allFetch('Order/OrderReleaseUpdateDate', obj);

/**訂單修改領牌資訊 (參數)
*  @description 訂單修改領牌資訊 (參數)
*  @param order_id 訂單系統編號
*  @param licensed_date 領牌日期
*  @param license_plate 車牌號碼
*/
export interface OrderUpdateLicensedInfoParams {
    order_id: string,
    licensed_date: string,
    license_plate: string,

}

/** @description  訂單修改領牌資訊 */
export const OrderUpdateLicensedInfo =
    async (obj: OrderUpdateLicensedInfoParams = {
        order_id: '',
        licensed_date: '',
        license_plate: '',

    }): Promise<ResultObj> => await allFetch('Order/OrderUpdateLicensedInfo', obj);



/**訂單確認領牌 (參數)
*  @description 訂單確認領牌 (參數)
*  @param order_id 訂單系統編號
*/
export interface OrderLicensedCheckParams {
    order_id: string
}

/** @description  訂單確認領牌 (回傳)*/
export interface OrderLicensedCheckResItem {
    is_licensed_check: string,
    licensed_check_endorse_user_id: string,
    licensed_check_endorse_user_name: string,
    licensed_check_time: string,
}

/** @description  訂單確認領牌 */
export const OrderLicensedCheck =
    async (obj: OrderLicensedCheckParams = {
        order_id: ''

    }): Promise<ResultObj<OrderLicensedCheckResItem>> => await allFetch('Order/OrderLicensedCheck', obj);

/**訂單確認放行 (參數)
*  @description 訂單確認放行 (參數)
*  @param order_id 訂單系統編號
*/
export interface OrderReleaseCheckParams {
    order_id: string,
}

/** @description  訂單確認放行 (回傳)*/
export interface OrderReleaseCheckResItem {
    is_release_check: string,
    release_check_endorse_user_id: string,
    release_check_endorse_user_name: string,
    release_check_time: string,
}

/** @description  訂單確認放行 */
export const OrderReleaseCheck =
    async (obj: OrderLicensedCheckParams = {
        order_id: ''

    }): Promise<ResultObj<OrderReleaseCheckResItem>> => await allFetch('Order/OrderReleaseCheck', obj);


//-----------------------------------------------------------------------------
/**(KT) 訂單受定修改 (參數)
*  @description (KT) 訂單受定修改 (參數)
*  @param order_id 訂單系統編號 (必)
*  @param autodms_order_number AutoDMS訂單編號
*  @param contract_date 簽約日期
*  @param order_potential_customer 訂單潛客部分
*  @param order_car 訂單車型部分
*  @param order_components 訂單配件部分
*  @param order_payment 訂單入金部分
*  @param order_loan 訂單貸款部分

*  @description 以下為客製化欄位
*  @param order_type 訂購類型
*  @param car_status 車輛狀態
*  @param energy_type 能源種類
*  @param purchase_method 購買方式
*  @param loan_interest_method 車貸利息
*  @param production_place 產地
*  @param displacement 排氣量或馬力
*  @param sunroof 天窗有無 ("Y"/"N")
*  @param other_agreement 其他約定事項
*  @param predict_licensed_date 預計領牌日期 (8)
*  @param predict_arrive_date 預計到港 (8)
*  @param predict_pay_price 約定現金交易車價
*  @param licenser_customer_name 領牌人名稱
*  @param licenser_address_contact 領牌人地址
*/
export interface OrderSubscribeUpdateKTParams {
    order_id: string,
    autodms_order_number: string,
    contract_date: string,
    order_potential_customer: {
        potential_is_orderer: string; // 潛客是否購買人
        potential_customer_id: string; // 潛客流水號
        orderer_customer_name: string; // 訂購人名稱
        orderer_identity_number: string; // 訂購人身分證
        orderer_cellphone: string; // 訂購人電話
        orderer_address_contact: string; // 訂購人地址
        orderer_birthday: string; // 訂購人生日
        orderer_email: string; // 訂購人信箱
        potential_customer_name: string; // 客戶名稱
        source: string; // 資料來源
        level: string; // 等級
        cellphone: string; // 行動電話
        address_contact: string; // 聯絡地址
        chance_number: string; // 機會編號
        identity_number: string; // 身分證
        email: string; // 電子郵件
        birthday: string; // 生日
    },
    order_car: {
        _PR_bonus_price?: string; // 公關車交車獎金
        ctf_id?: number | string; // 車型定價流水號
        ce_id?: number | string; // 車型外裝加價流水號
        ci_id?: number | string; // 車型內裝加價流水號
        year?: string; // 年份
        year_age?: number | string; // 年齡 (必需)
        is_self_licensed: string; // 是否自領牌 (必需)
        is_car_limit: string; // 是否限定車 (必需)
        cs_id?: string; // 車流水號
        abnormal_sale_type?: string; // 異常銷售種類
        note?: string; // 銷顧備註
        PR_bonus_user_id?: string; // 公關車交車獎金領受人
        PR_bonus_price?: number | string; // 公關車交車獎金
        ctfp_id?: number | string; // 車型規格定價流水號
        ctep_id?: number | string; // 車型外裝加價流水號
        ctip_id?: number | string; // 車型內裝加價流水號
    },
    order_components: {
        /** Optional: 計入交易支付價格 */
        transaction_pay_price: string | number;
        /** Optional: 客戶付價格 */
        deductible_pay_price: string | number;
        /** Optional: 公司付價格 */
        company_pay_price: string | number;
        /** Optional: 總公司付價格 */
        headquarters_pay_price: string | number;
        /**  Optional: 庫存流水號 */
        stock_id: string;
        /** Required: 商品流水號 */
        commodity_id: string;
        /** Required: 單位換算流水號 */
        uc_id: string;
        /** Optional: 自訂屬性細項流水號1 */
        ccad_id_1: string;
        /** Optional: 自訂屬性細項流水號2 */
        ccad_id_2: string;
        /** Required: 是否計算庫存 */
        need_calc_stock: string;
        /** Optional: 配件類別 */
        component_type: string;
        /** Required: 配件名稱 */
        component_name: string;
        /** Optional: 單價 */
        price: string;
        /** Optional: 數量 */
        count: string;
        /** Optional: 備註 */
        note: string;
    }[],
    order_payment: {
        company_rule: string | number; // Optional: 公司規範(最少訂金)
        order_payment_details: {
            isdeposit: string; // 是否訂金
            payment: string; // 付款方式
            transfer_out_bank: string; // Optional: 匯款轉出銀行
            transfer_out_account: string; // Optional: 匯款轉出帳號
            transfer_in_bank: string; // Optional: 匯款轉入銀行
            transfer_in_account: string; // Optional: 匯款轉入帳號
            transfer_in_date: string; // Optional: 匯款轉入日期
            transfer_in_price: number | null; // Optional: 匯款入金金額
            check_pay_bank: string; // Optional: 支票付款銀行
            check_number: string; // Optional: 支票票號
            check_receive_bank: string; // Optional: 支票貸收銀行
            check_receive_date: string; // Optional: 支票貸收日期
            check_expired_date: string; // Optional: 支票到期日
            check_price: number | null; // Optional: 支票入金金額
            swipe_in_bank: string; // Optional: 刷卡轉入銀行
            swipe_in_account: string; // Optional: 刷卡轉入帳號
            swipe_price: number | null; // Optional: 刷卡入金金額
            swipe_handling_fee: number | null; // Optional: 刷卡手續費
            innertransfer_out_bank: string; // Optional: 內轉轉出銀行
            innertransfer_out_date: string; // Optional: 內轉轉出日期
            innertransfer_out_price: number | null; // Optional: 內轉轉出金額
            innertransfer_out_method: string; // Optional: 內轉轉出方式
            innertransfer_summon_code: string; // Optional: 內轉轉出傳票號碼
            note: string; // Optional: 備註
            overcharge: number | null; // Optional: 溢收
        }[];
    },
    order_loan: {
        loan_agency: string,
        loan_bank_insurance_date: string,
        loan_bank_predict_price: number | string
    },
    order_insurance: {
        insurance_id?: string; // 保險流水號
        insurance_name?: string; // 保險名稱
        insurance_price?: number; // 保險報價金額
        insurance_type?: string; // 保險種類
        insurance_type_name?: string; // 保險種類名稱
        insurance_company_id?: string; // 保險公司流水號
        insurance_company_code?: string; // 保險公司代號
        insurance_company_name?: string; // 保險公司名稱
        note?: string; // 備註
    },
    // 多的
    order_type: string,
    car_status: string,
    energy_type: string,
    purchase_method: string,
    loan_interest_method: string,
    production_place: string,
    displacement: string,
    sunroof: string,
    other_agreement: string,
    predict_licensed_date: string,
    predict_arrive_date: string,
    predict_pay_price: number | string,
    licenser_customer_name: string,
    licenser_address_contact: string

}

/**@description (KT) 訂單受定修改 */
export const OrderSubscribeUpdateKT =
    async (obj: OrderSubscribeUpdateKTParams): Promise<ResultObj> => await allFetch('OrderKT/OrderSubscribeUpdateKT', obj);



/**(KT) 訂單細項 (參數)
*  @description (KT) 訂單細項 (參數)
*  @param order_id 訂單系統編號
*/
export interface OrderDetailKTParams {
    order_id: string,
}

/** @description (KT) 訂單細項 (回傳)*/
export interface OrderDetailKTResItem {
    dt: {
        PR_bonus_price: number;
        PR_bonus_user_id: string;
        SIDO_no: string;
        abnormal_sale_type: string;
        accounting_check_time: string;
        actual_actual_condition_sum: number;
        actual_difference_price: number;
        actual_pay_price: number;
        autodms_order_number: string;
        car_type: string;
        car_type_price: number;
        cash_nondeductible: number;
        cash_subsidy_deductible: number;
        cash_subsidy_nondeductible: number;
        ce_id: number;
        ci_id: number;
        company_rule: number;
        component_own_expense_sum: number;
        component_price_sum: number;
        component_subsidy_deductible_sum: number;
        component_subsidy_nondeductible_sum: number;
        contract_date: string;
        cre_time: string;
        cs_id: string;
        ct_id: number;
        ctep_id: number;
        ctf_id: number;
        ctfp_id: number;
        ctip_id: number;
        cus_agree_time: string;
        custody_unit_id: string;
        custody_user_cre_time: string;
        custody_user_id: string;
        custody_user_name: string;
        delivery_date: string;
        deposit_sum: number;
        dispatch_car_time: string;
        exterior_code: string;
        exterior_color: string;
        exterior_price: number;
        extraction_date: string;
        first_audit_time: string;
        first_submit_time: string;
        format_code: string;
        format_name: string;
        insurance_company: string;
        insurance_price: number;
        interior_code: string;
        interior_color: string;
        interior_price: number;
        invoice_check_time: string;
        is_accounting_check: string;
        is_car_limit: string;
        is_dispatched: string;
        is_invoice_check: string;
        is_licensed_check: string;
        is_release_check: string;
        is_self_licensed: string;
        license_plate: string;
        licensed_check_endorse_user_id: string;
        licensed_check_time: string;
        licensed_date: string;
        licenser_address_contact: string;
        licenser_birthday: string;
        licenser_cellphone: string;
        licenser_customer_name: string;
        licenser_email: string;
        licenser_identity_number: string;
        licenser_is_orderer: string;
        loan_agency: string;
        loan_bank_insurance_date: string;
        loan_bank_predict_price: number;
        loan_company_subsidy_price: number;
        loan_predict_subsidy_price: number;
        note: string;
        order_id: string;
        order_number: string;
        order_status: string;
        orderer_address_contact: string;
        orderer_birthday: string;
        orderer_cellphone: string;
        orderer_customer_name: string;
        orderer_email: string;
        orderer_identity_number: string;
        over_discount_note: string;
        over_discount_price: number;
        over_discount_price_sum: number;
        pc_cre_time: string;
        potential_customer_address_contact: string;
        potential_customer_cellphone: string;
        potential_customer_chance_number: string;
        potential_customer_id: string;
        potential_customer_level: string;
        potential_customer_level_name: string;
        potential_customer_name: string;
        potential_customer_source: string;
        potential_customer_source_name: string;
        potential_is_orderer: string;
        predict_actual_condition_sum: number;
        predict_balance: number;
        predict_delivery_date: string;
        predict_difference_price: number;
        predict_licensed_date: string;
        predict_pay_price: number;
        promotion_condition_sum: number;
        release_check_endorse_user_id: string;
        release_check_time: string;
        stop_dispatch: string;
        store_department: string;
        upd_time: string;
        user_address_contact: string;
        user_birthday: string;
        user_cellphone: string;
        user_customer_name: string;
        user_email: string;
        user_identity_number: string;
        user_is_orderer: string;
        vin_no: string;
        year: string;
        year_age: number;
    }[],
    dt_KT: {
        car_status: string;
        displacement: string;
        energy_type: string;
        loan_interest_method: string;
        order_type: string;
        other_agreement: string;
        predict_arrive_date: string;
        production_place: string;
        purchase_method: string;
        sunroof: string;
    }[],
    dt_order_components: (OrderCarComponentParams &
    {
        occ_id: number, // 配件ID
        /** 計入交易車價金額 */
        transaction_pay_price: number,
        /** 客戶自費金額 */
        deductible_pay_price: number,
        /** 公司付 */
        company_pay_price: number,
        /** 總公司付 */
        headquarters_pay_price: number,
        /** 備註 JSON格式
         * {plant: string,
         * plant_name: string
         * note: string}
         */
        note: string // 備註
    })[],
    dt_order_invoice: [],
    dt_order_payment: {
        abnormal_sale_type: null | string; // 非正常销售类型
        category: null | string; // 类别
        check_expired_date: string; // 支票到期日
        check_number: string; // 支票票号
        check_pay_bank: string; // 支票付款银行
        check_price: number; // 支票入金金额
        check_receive_bank: string; // 支票贷收银行
        check_receive_date: string; // 支票贷收日期
        commodity_id: null | string; // 商品流水号
        cs_id: null | string; // 车流水号
        csc_id: null | string; // 车身流水号
        csd_id: null | string; // 车色流水号
        csm_id: null | string; // 车型流水号
        deductible: null | string; // 可扣除额度
        documet_source: null | string; // 文档来源
        innertransfer_out_bank: string; // 内转转出银行
        innertransfer_out_date: string; // 内转转出日期
        innertransfer_out_method: string; // 内转转出方式
        innertransfer_out_price: number; // 内转转出金额
        innertransfer_summon_code: string; // 内转转出传票号码
        is_accounting: "N" | "Y"; // 是否计帐
        isdeposit: "N" | "Y"; // 是否订金
        label_big: null | string; // 大标签
        name: string; // 名称
        note: string; // 备注
        ocsd_id: null | string; // OCSD流水号
        op_id: number; // 操作人员ID
        order_id: string; // 订单ID
        overcharge: number; // 溢收
        payment: string; // 付款方式
        price: null | number; // 价格
        swipe_handling_fee: number; // 刷卡手续费
        swipe_in_account: string; // 刷卡转入帐号
        swipe_in_bank: string; // 刷卡转入银行
        swipe_price: number; // 刷卡入金金额
        transfer_in_account: string; // 匯款轉入帳號
        transfer_in_bank: string; // 匯款轉入銀行
        transfer_in_date: string; // 匯款轉入日期
        transfer_in_price: number; // 匯款入金金額
        transfer_out_account: string; // 匯款轉出帳號
        transfer_out_bank: string; // 匯款轉出銀行
        type: null | string; // 类型
        uc_id: null | string; // 单位换算流水号
        upd_time: string; // 更新时间
        upd_userid: string; // 更新用户ID
        user_cre_time: string; // 用户创建时间
        username: string; // 用户名
    }[],
    dt_order_subsidy: [],
    dt_order_insurance: OrderInsurance[],
}

/** @description (KT) 訂單細項 (回傳)*/
export const OrderDetailKT =
    async (obj: OrderDetailKTParams = {
        order_id: '',
    }): Promise<ResultObj<OrderDetailKTResItem>> => await allFetch('OrderKT/OrderDetailKT', obj);


/** (KT) 產生訂單給客人同意的token (參數)
*  @description (KT) 產生訂單給客人同意的token (參數)
*  @param order_id 訂單系統編號
*/
export interface OrderGenerateAgreeTokenKTParam {
    order_id: string,
}

/** @description (KT) 產生訂單給客人同意的token)*/
export const OrderGenerateAgreeTokenKT =
    async (obj: OrderGenerateAgreeTokenKTParam = {
        order_id: ''
    }): Promise<ResultObj> => await allFetch('OrderKT/OrderGenerateAgreeTokenKT', obj);

/**(KT) 驗證token 時效 查訂單資訊
*  @description  (KT) 驗證token 時效 查訂單資訊
*  @param token 驗證碼
*/
export const OrderCheckTokenKT =
    async (obj = {
        token: ''
    }): Promise<ResultObj> => await allFetch('OrderKT/OrderCheckTokenKT', obj);

/** (KT) 客人同意訂單內容 (參數)
*  @description (KT) 產生訂單給客人同意的token (參數)
*  @param token 驗證碼
*  @param pdf_html 要轉pdf的html
*  @param header_html html的header
*  @param header_height html的header的高度(inch)
*/
export interface OrderCustomerAgreeKTParam {
    token: string,
    pdf_html: string,
    header_html: string,
    header_height: string,
}

/** @description (KT) 客人同意訂單內容*/
export const OrderCustomerAgreeKT =
    async (obj: OrderCustomerAgreeKTParam = {
        token: '',
        pdf_html: '',
        header_html: '',
        header_height: ''
    }): Promise<ResultObj> => await allFetch('OrderKT/OrderCustomerAgreeKT', obj);

/** (KT) 訂單審核中途修改配件備註 (參數)
*  @description (KT) 產生訂單給客人同意的token (參數)
*  @param order_id 訂單號碼
*  @param occ_list 欲修改配件陣列
*  @param occ_id 配件id
*  @param note 備註
*/
export interface OrderUpdateCarComponentParam {
    order_id: string,
    occ_list: {
        occ_id: number,
        note: string
    }[]
}

/** @description (KT) 訂單審核中途修改配件備註*/
export const OrderUpdateCarComponent =
    async (obj: OrderUpdateCarComponentParam): Promise<ResultObj> =>
        await allFetch('OrderKT/OrderUpdateCarComponent', obj);




//------------------------------------------------

/**訂單轉讓查詢 查可轉讓訂單(非異常、未送審) (參數)
 * @description 訂單轉讓查詢 查可轉讓訂單(非異常、未送審) (參數) 
 * @param order_number 訂單編號
 * @param custody_user_id 保管人流水號
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 * */
export interface OrderTransferSearchParams {
    order_number: string,
    custody_user_id: string,
    can_transfer_apply: string;
    page: number,
    num_per_page: number
}

/**@description 訂單轉讓查詢 查可轉讓訂單(非異常、未送審) (回傳) */
export interface OrderTransferSearchResItem {
    custody_user_id: string;
    order_id: string;
    order_number: string;
    user_cre_time: string;
    user_name: string;
    can_transfer_apply: string;
}

/**@description 訂單轉讓查詢 查可轉讓訂單(非異常、未送審) */
export const OrderTransferSearch =
    async (obj: OrderTransferSearchParams): Promise<ResultObj<OrderTransferSearchResItem[]>> => await allFetch('Order/OrderTransferSearch', obj);

/**訂單轉讓申請 (參數)
 * @description 訂單轉讓申請 (參數) 
 * @param order_id 訂單系統編號
 * @param note 備註
 * */
export interface OrderTransferCreateParams {
    order_id: string,
    note: string,
}

/**@description 訂單轉讓申請 */
export const OrderTransferCreate =
    async (obj: OrderTransferCreateParams): Promise<ResultObj> => await allFetch('Order/OrderTransferCreate', obj);

/**訂單轉讓申請確認 (參數)
* @description 訂單轉讓申請確認 (參數) 
* @param order_id 訂單系統編號
* @param note 備註
* */
export interface OrderTransferCheckParams {
    ocl_id: string,
    is_transfer_agree: string,
}

/**@description 訂單轉讓申請確認 */
export const OrderTransferCheck =
    async (obj: OrderTransferCheckParams): Promise<ResultObj> => await allFetch('Order/OrderTransferCheck', obj);

/**訂單轉讓紀錄查詢 (參數)
* @description 訂單轉讓紀錄查詢 (參數) 
* @param ocl_id 訂單保管紀錄流水號
* @param order_id 訂單系統編號
* @param custodyfrom_user_id 來源保管人
* @param custody_user_id 目標保管人
* @param is_transfer_check 是否已確認
* @param is_transfer_agree 是否同意轉轉讓
* @param page 頁碼
* @param num_per_page 一頁幾筆
* */
export interface OrderTransferLogSearchParams {
    ocl_id: string,
    order_id: string,
    custodyfrom_user_id: string,
    custodyto_user_id: string,
    is_transfer_check: string,
    is_transfer_agree: string,
    page: number,
    num_per_page: number
}

/**@description 訂單轉讓紀錄查詢 (回傳) */
export interface OrderTransferLogSearchResItem {
    custodyfrom_unit_id: string;
    custodyfrom_unit_name: string;
    custodyfrom_user_cre_time: string;
    custodyfrom_user_id: string;
    custodyfrom_user_name: string;
    custodyto_unit_id: string;
    custodyto_unit_name: string;
    custodyto_user_cre_time: string;
    custodyto_user_id: string;
    custodyto_user_name: string;
    is_transfer_agree: string;
    is_transfer_check: string;
    note: string;
    ocl_id: number;
    order_id: string;
    order_number: string;
}

/**@description 訂單轉讓紀錄查詢 */
export const OrderTransferLogSearch =
    async (obj: OrderTransferLogSearchParams): Promise<ResultObj<OrderTransferLogSearchResItem[]>> => await allFetch('Order/OrderTransferLogSearch', obj);

/** 匯出新車配件表 (參數)
* @param licensed_check_time_start 領牌日期起
* @param licensed_check_time_end 領牌日期迄
* @param first_audit_time_start 審核日期起
* @param first_audit_time_end 審核日期迄
* @param final_payment_time_start 全款日期起 
* @param final_payment_time_end 全款日期迄 
* @param excel 是否匯出
* @param page 頁碼
* @param num_per_page 一頁幾筆
* */
export interface OrderReportParams {
    licensed_check_time_start?: string,
    licensed_check_time_end?: string,
    first_audit_time_start?: string,
    first_audit_time_end?: string,
    final_payment_time_start?: string,
    final_payment_time_end?: string,
    excel?: string,
    page: number,
    num_per_page: number
}

/** 匯出新車配件表 */
export const OrderReport =
    async (obj: OrderReportParams): Promise<ResultObj<string>> => await allFetch('Order/OrderReport', obj);


/**@description 更新領牌應收資料 */
export const OrderDeliveryInfoUpdate =
    async (obj: OrderDeliveryInfoUpdateParams): Promise<ResultObj> => await allFetch('Order/OrderDeliveryInfoUpdate', obj);

/**更新領牌應收資料 (參數)
* @description 更新領牌應收資料 (參數) 
* @param order_id 訂單系統編號
* @param predict_recovery_date 預計回收日期
* @param delivery_note 交車備註
* @param predict_delivery_date 預計交車日期
* */
export interface OrderDeliveryInfoUpdateParams {
    order_id: string,
    predict_recovery_date: string,
    delivery_note: string,
    predict_delivery_date: string,
}

/**@description 搜尋新車訂單報表 */
export const OrderNewCarReceivableReport =
    async (obj: OrderNewCarReceivableReportParams): Promise<ResultObj<OrderNewCarReceivableReportResItem[]>> => await allFetch('Order/OrderNewCarReceivableReport', obj);


/**搜尋新車訂單報表 (參數)
* @description 搜尋新車訂單報表 (參數) 
* @param order_number 訂單編號
* @param autodms_order_number AutoDMS訂單號碼
* @param custody_unit_id 保管單位
* @param custody_user_id 保管人
* @param licenser_customer_name 領牌人
* @param receivable_amount 應收總金額
* @param actual_pay_price 實際繳入總金額 
* @param predict_balance 預估餘款
* @param predict_recovery_date 預計回收日
* @param predict_delivery_date 預計交車日
* @param invoice_date 發票日期
* @param note 備註
* @param page 頁碼
* @param num_per_page 一頁幾筆
* @param excel 是否匯出
* */
export interface OrderNewCarReceivableReportParams {
    order_number?: string,
    autodms_order_number?: string,
    custody_unit_id?: string,
    custody_user_id?: string,
    licenser_customer_name?: string,
    receivable_amount?: string,
    actual_pay_price?: string,
    predict_balance?: string,
    predict_recovery_date?: string,
    predict_delivery_date?: string,
    invoice_date?: string,
    note?: string,
    page?: number,
    num_per_page?: number,
    excel?: string
}

/**搜尋新車訂單報表 (回傳)
* @description 搜尋新車訂單報表 (回傳) 
* @param actual_pay_price 實際繳入總金額
* @param autodms_order_number AutoDMS訂單號碼
* @param custody_unit_id 保管單位
* @param custody_user_id 保管人
* @param invoice_date 發票日期
* @param invoice_price_sum 發票總金額
* @param licenser_customer_name 領牌人
* @param note 備註
* @param order_number 訂單編號
* @param predict_balance 預估餘款
* @param predict_delivery_date 預計交車日
* @param predict_recovery_date 預計回收日
* @param receivable_amount 應收總金額
*/
export interface OrderNewCarReceivableReportResItem {
    actual_pay_price: number,
    autodms_order_number: string,
    custody_unit_id: string,
    custody_user_id: string,
    invoice_date: string,
    invoice_price_sum: number,
    licenser_customer_name: string,
    note: string,
    order_number: string,
    predict_balance: number,
    predict_delivery_date: string,
    predict_recovery_date: string,
    receivable_amount: number,


}